import { Liquid } from "liquidjs";
import { LiquidVariable } from "../services/bedrock";

const engine = new Liquid();
export const LIQUID_PLACEHOLDER_REGEX = /{{.*?}}|{%-?.*?-?%}/;

export const convertLiquidVariablesToObject = (liquidVariables: LiquidVariable[]): { [key: string]: any } => {
  const obj: { [key: string]: any } = {};
  liquidVariables.forEach(variable => {
    if (variable.dataType === "liquid_drop") {
      obj[variable.name] = convertLiquidVariablesToObject(variable.value as LiquidVariable[]);
    } else {
      obj[variable.name] = variable.value;
    }
  });
  return obj;
};

export const renderLiquidInObject = (obj: any, liquidVariables: any): any => {
  if (!LIQUID_PLACEHOLDER_REGEX.test(JSON.stringify(obj))) {
    return obj;
  }
  if (typeof obj === "string") {
    try {
      return engine.parseAndRenderSync(obj, liquidVariables);
    } catch (e) {
      return obj;
    }
  } else if (Array.isArray(obj)) {
    return obj.map(item => renderLiquidInObject(item, liquidVariables));
  } else if (obj && typeof obj === "object") {
    const entries = Object.entries(obj).map(([key, value]) => {
      const renderedValue = renderLiquidInObject(value, liquidVariables);
      return [key, renderedValue];
    });
    return Object.fromEntries(entries);
  } else {
    return obj;
  }
};

export const getLiquidErrorMessage = (text: string): string | null => {
  try {
    engine.parse(text);
    return null;
  } catch (e: any) {
    return e.message || null;
  }
};
